import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { ObservationExtended } from "@/assessments-and-vitals/types/assessments-vitals";

import { RootState } from "..";

const assessmentsVitalsAdapter = createEntityAdapter({
  selectId: (observation: ObservationExtended) => observation.id!,
});

const reducers = {
  loadAssessmentsVitalsObservations: assessmentsVitalsAdapter.setAll,
  createManyAssessmentsVitalsObservations: assessmentsVitalsAdapter.addMany,
  createAssessmentsVitalsObservation: assessmentsVitalsAdapter.addOne,
  removeAssessmentsVitalsObservation: assessmentsVitalsAdapter.removeOne,
  updateAssessmentsVitalsObservation: assessmentsVitalsAdapter.updateOne,
};

export const assessmentsVitalsSlice = createSlice({
  name: "assessmentsVitals",
  initialState: assessmentsVitalsAdapter.getInitialState(),
  reducers,
});

export const {
  loadAssessmentsVitalsObservations,
  createAssessmentsVitalsObservation,
  createManyAssessmentsVitalsObservations,
  removeAssessmentsVitalsObservation,
  updateAssessmentsVitalsObservation,
} = assessmentsVitalsSlice.actions;

const selectAssessmentsVitalsObservationsEntities = (state: RootState) =>
  state.assessmentsVitals.entities;

export const selectAssessmentsVitalsObservationsList = createSelector(
  [selectAssessmentsVitalsObservationsEntities],
  (assessmentsVitalsEntities): ObservationExtended[] => Object.values(assessmentsVitalsEntities),
);

export default assessmentsVitalsSlice.reducer;
